module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_shikaku-f851262426442cbf0f18ddfd5c6f1bc7.png";